<div class="grid grid-cols-12 gap-4 form p-0">
  <div class="col-span-12 mt-4 mb-1">
    <div class="flex w-full justify-center">
      <p-selectButton
        class="mitigation-selectbutton"
        [options]="MITIGATION_MODE_OPTIONS"
        [(ngModel)]="mode"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false" />
    </div>
  </div>
  <div class="col-span-12">
    <ng-container [ngSwitch]="mode">
      <!-- Automated Workflow Component  -->
      <ng-container *ngSwitchCase="MITIGATION_MODES.WORKFLOW">
        <app-mitigation-workflow [threat]="threat" [threatGroup]="threatGroup" />
      </ng-container>
      <!-- Recommendation Component  -->
      <ng-container *ngSwitchCase="MITIGATION_MODES.RECOMMEND">
        <app-mitigation-recommendation [threat]="threat" [threatGroup]="threatGroup" />
      </ng-container>
    </ng-container>
  </div>
</div>
